import { Link, useLocation } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";

/**
 * Discreet, persistent Staff Portal link rendered on every customer-facing
 * page (homepage, booking flow, policy pages) regardless of campaign or
 * operating mode. Hidden on auth/portal routes since those already provide
 * staff context.
 */
export default function StaffPortalCornerLink() {
  const location = useLocation();
  const path = location.pathname || "/";

  // Hide on routes that are already staff-facing OR on the customer
  // self-check-in kiosk — the kiosk must not expose any operational chrome.
  // Marketing V2 public routes (/v2/c/:campaignId) MUST render as a
  // customer-safe surface with zero internal shell leakage per the V2
  // design acceptance pass.
  const hide =
    path.startsWith("/portal") ||
    path === "/login" ||
    path === "/register" ||
    path === "/checkin" ||
    path.startsWith("/v2/");
  if (hide) return null;

  return (
    <Link
      to="/login"
      className="fixed bottom-3 left-3 z-40 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/65 hover:bg-black/85 text-white text-[11px] font-medium shadow-md backdrop-blur-sm transition-colors"
      data-testid="staff-portal-corner-link"
      title="Staff Portal sign-in"
    >
      <Lock className="w-3 h-3" weight="fill" />
      Staff Portal
    </Link>
  );
}
